module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.changelog.app_changelog) ? _c('li', {
    staticClass: "update"
  }, [_c('ul', {
    staticClass: "log-list"
  }, _vm._l((_vm.changelog.app_changelog), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "log-item clearfix"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v("\n        " + _vm._s(item.update_time) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "detail"
    }, [_c('dl', {
      staticClass: "log"
    }, [_c('dt', [_vm._v("更新 " + _vm._s(item.update_version))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm._f("formatHtml")(item.update_content)))])])])])
  }), 0), _vm._v(" "), (_vm.page.curPage != _vm.page.totalPage) ? _c('div', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("\n    加载更多\n  ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2da41338!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application/update.vue
// module id = pwZy
// module chunks = 0